'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var AirConditioner = function (_React$Component) {
    _inherits(AirConditioner, _React$Component);

    function AirConditioner() {
        _classCallCheck(this, AirConditioner);

        return _possibleConstructorReturn(this, (AirConditioner.__proto__ || Object.getPrototypeOf(AirConditioner)).apply(this, arguments));
    }

    _createClass(AirConditioner, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M1.066 11.434h23.461c0.294 0 0.56 0.12 0.753 0.313s0.313 0.46 0.313 0.753v4.999c0 0.844-0.345 1.61-0.9 2.166s-1.322 0.9-2.166 0.9h-19.462c-0.844 0-1.61-0.345-2.166-0.9s-0.9-1.322-0.9-2.166v-4.999c0-0.294 0.12-0.56 0.313-0.753s0.46-0.313 0.753-0.313zM24.528 12.234h-23.461c-0.073 0-0.139 0.030-0.188 0.079s-0.079 0.115-0.079 0.188v4.999c0 0.623 0.255 1.189 0.666 1.6s0.977 0.666 1.6 0.666h19.462c0.623 0 1.189-0.255 1.6-0.666s0.666-0.977 0.666-1.6v-4.999c0-0.073-0.030-0.139-0.079-0.188s-0.115-0.079-0.188-0.079z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M21.728 20.566h-17.863c-0.221 0-0.4-0.179-0.4-0.4v-1.266c0-0.294 0.12-0.56 0.313-0.753s0.46-0.313 0.754-0.313h16.53c0.294 0 0.56 0.12 0.753 0.313s0.313 0.46 0.313 0.753v1.266c0 0.221-0.179 0.4-0.4 0.4zM4.265 19.766h17.063v-0.866c0-0.073-0.030-0.139-0.079-0.188s-0.115-0.079-0.188-0.079h-16.53c-0.073 0-0.139 0.030-0.188 0.079s-0.079 0.115-0.079 0.188v0.866z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M2.899 12.92c0.289 0 0.523 0.234 0.523 0.523s-0.234 0.523-0.523 0.523c-0.289 0-0.523-0.234-0.523-0.523s0.234-0.523 0.523-0.523z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M2.899 14.594c0.289 0 0.523 0.234 0.523 0.523s-0.234 0.523-0.523 0.523c-0.289 0-0.523-0.234-0.523-0.523s0.234-0.523 0.523-0.523z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M2.899 16.268c0.289 0 0.523 0.234 0.523 0.523s-0.234 0.523-0.523 0.523c-0.289 0-0.523-0.234-0.523-0.523s0.234-0.523 0.523-0.523z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M10.879 16.239c-0.221 0-0.4 0.179-0.4 0.4s0.179 0.4 0.4 0.4h3.837c0.221 0 0.4-0.179 0.4-0.4s-0.179-0.4-0.4-0.4h-3.837z' })
            );
        }
    }]);

    return AirConditioner;
}(_react2.default.Component);

AirConditioner.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = AirConditioner;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/air-conditioner.js
// module id = 1083
// module chunks = 0